// Added by Jonghyung Lee on 2021-12-14
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { createStyles, Theme, makeStyles, useTheme } from '@material-ui/core'

// Helper
import Intl from '@/helper/Intl'
import { WPSWorks } from '@/helper/define/wpsDefine'

// UI
import { DialogWrapper, DialogWrapperProps } from '@/components/common/v2/Dialog/DialogWrapper'
import { Button } from '@/components/worklist/Button'
import WPSMonitorignDetailTable from './WPSMonitoringDetailTable'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
export interface WPSMonitoringDetailProps extends Partial<DialogWrapperProps> {
  waitingTasks?: WPSWorks[]
  runningTasks?: WPSWorks[]
  btnTextOk?: string
  proxyToken?: string | null
  /** WC용 Styles  */
  classes?: any
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const WPSMonitoringDetail = ({
  open,
  onCloseBtnClick,
  waitingTasks = [],
  runningTasks = [],
  proxyToken,
  ...rest
}: WPSMonitoringDetailProps) => {
  useTheme()
  const classes = useStyles()

  const title = Intl.getIntlText({ id: 'htmljs_react.worklist.wpsmonitoringdetail.title' })
  const btnTextOk = Intl.getIntlText({ id: 'htmljs_react.worklist.wpsmonitoringdetail.btn_ok' })
  const tableTitle = Intl.getIntlText({ id: 'htmljs_react.worklist.wpsmonitoringdetail.table_title' })

  const getDialogWidth = () => {
    const innerWidth = window.innerWidth * 0.8
    return 1280 > innerWidth ? innerWidth : 1280
  }

  return (
    <DialogWrapper
      open={open!}
      title={title}
      onCloseBtnClick={onCloseBtnClick!}
      minwidth={getDialogWidth()}
      maxWidth={'lg'}
    >
      <div className={classes.contentWrapper}>
        <WPSMonitorignDetailTable
          tableTitle={tableTitle}
          proxyToken={proxyToken}
          tasks={[...runningTasks, ...waitingTasks]}
        />
      </div>
      <div className={classes.ctrWrapper}>
        <div className={classes.ctrRow}>
          <Button disabled={false} onBtnClick={onCloseBtnClick!}>
            {btnTextOk}
          </Button>
        </div>
      </div>
    </DialogWrapper>
  )
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    contentWrapper: {
      padding: '8px',
      fontSize: '11px',
    },
    ctrWrapper: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0 8px 8px 8px',
    },
    ctrRow: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      color: '#e6eaec',
    },
    divider: {
      width: '100%',
      height: '1px',
      background: '#000',
      marginTop: theme.spacing(),
    },
  })
)

export default WPSMonitoringDetail
